export default {
  meta: {
    title: '概览',
  },
};
